var SkinUtils = (function() {
	
	var getClass = function(skin) {
		switch (skin) {
		case "sfa":
			return "vjs-sfa-skin";
		case "sfa-classic":
			return "vjs-sfa-skin sfa-classic";
		case "sf-kids":
			return "vjs-sf-kids-skin";
		case "sf-kids-lite":
			return "vjs-sf-kids-skin vjs-sf-kids-lite";
		default:
			throw "undefined skin";
		}
	};
	
	var getControls = function(skin) {
		switch (skin) {
		case "sfa":
			return [
				"fullscreenToggle",
				"playToggle",
				"volumeControl",
				"muteToggle",
				"progressControl",
				"subtitlesButton",
				"durationDisplay",
				"timeDivider",
				"currentTimeDisplay"
			];
		case "sfa-classic":
			return [
				"fullscreenToggle",
				"playToggle",
				"volumeControl",
				"muteToggle",
				"progressControl",
				"subtitlesButton",
				"durationDisplay",
				"timeDivider",
				"currentTimeDisplay"
			];
		case "sf-kids":
			return [
				"fullscreenToggle",
				"volumeControl",
				"muteToggle",
				"progressControl",
				"currentTimeDisplay",
				"RemainingTimeDisplay"
			];			
		case "sf-kids-lite":
			return [
				"playToggle"
			];
		default:
			throw "undefined skin";
		}
	};
	
	var getFeatures = function(skin) {
		switch (skin) {
		case "sfa":
			return [
				"hotKeys",
				"progressTips"
			];
		case "sfa-classic":
			return [
				"hotKeys",
				"closeButton",
				"progressTips"
			];
		case "sf-kids":
			return [
				"hotKeys",
				"progressTips"
				//"airPlay",
			];			
		case "sf-kids-lite":
			return [];
		default:
			throw "undefined skin";
		}
		
	};

	return {
		getClass: getClass,
		getControls: getControls,
		getFeatures: getFeatures
	};
})();
